import { media, styled, typography } from '@pulse-web-ui/theme';

export const Text = styled.h2`
  ${typography.medium20};
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};

  ${media.desktop} {
    ${typography.medium24};
  }
`;
